import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const Tooltip12week = () => {
  const { t } = useTranslation();

  return (
    <div className="info-tooltip" data-bem="Tooltip12week">
      <i>{t('clientConnect.tooltipGuide')}</i>
      <div className="client-info-icon">
        <span className="tooltip">
          <div className="tooltip-centered">{t('clientConnect.week12TooltipText')}</div>
        </span>
      </div>
    </div>
  );
};

export default Tooltip12week;
